<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cQ5FGw/tc-custom/9781467733014.jpg?1703358833583" alt="This image is the cover for the book Side Control, The Dojo"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Side Control, The Dojo
      </h1>
      <p class="bookDescription body article font2">
        <p>Jackson James wants three things: to succeed in MMA, to join the military like his father, and to protect his little brother from ending up in trouble like he did. But it's a challenge to stay in control of his life at school, at home, and at the dojo—especially with the distraction of Tyresha Harris, one of the new female fighters. When faced with tough choices, can Jackson learn to make the right ones inside the cage and out?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Jones
      </h2>
      
      <p class="authorDescription body article"><B>Patrick Jones </B>lives in Minneapolis and is the author of many novels including the <B>Support and Defend</B> series. A former librarian, Jones received lifetime achievement awards from the American Library Association and the Catholic Library Association.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Darby Creek
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8c185caa